import React from "react";

import { Tag } from "@chakra-ui/react";

const ActiveTag = () => {
  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#309C443f"}
      textColor={"#309C44"}
      borderRadius={"1.375rem"}
    >
      Active
    </Tag>
  );
};

const InactiveTag = () => {
  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#FF00003f"}
      textColor={"#FF0000"}
      borderRadius={"1.375rem"}
    >
      Inactive
    </Tag>
  );
};

export default function ActiveInactiveTags(props) {
  const size = "sm";

  const is_active = props.is_active;

  return <div>{is_active ? <ActiveTag /> : <InactiveTag />}</div>;
}
